import { FC, useContext, useEffect, useState } from "react";
import FooterText from "../../components/footerText";
import AuthSubHeader from "../../components/authSubHeader";
import { APIEndpoints } from "src/types/apiTypes";
import useFetch from "src/hooks/useFetch";
import {  ScheduleRepVisitApiResponse, repVisitUpdateError } from "./types";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import { AuthContext } from "src/context/authContext";
import { useNavigate } from "react-router-dom";



const NewRepVisit: FC = (): JSX.Element => {
  const [radioValue, setRadioValue] = useState("");

  const { showToast } = useContext(ToastContext);
  const { hideLoader } = useContext(LoaderContext);
  const { destroySession } = useContext(AuthContext);
  const navigate = useNavigate();

  const { loading, data: repVisitData, mutate: repVisit, error: repVisitError } =
    useFetch<ScheduleRepVisitApiResponse>(APIEndpoints.SCHEDULE_REP_VISIT, {}, {}, false)

  const scheduleRepVisit = () => {
      const requestBody = {
        reason: radioValue
      }
      repVisit(requestBody)
  }
  const onClickRadioButton = (value: string) => {
    setRadioValue(value)
  }
  useEffect(() => {
    if (repVisitError) {
      hideLoader();
      const {code, error } = repVisitError as unknown as repVisitUpdateError;
      showToast([error || `Can't Schedule Rep Visit right now. Please try again in a while.`], ToastTypes.ERROR);
      if (code === 401) {
        destroySession();
        showToast([`User session has expired`], ToastTypes.ERROR);
        navigate(`/users/sign_in`);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repVisitError]);

  useEffect(() => {
    if (repVisitData || repVisitError) {
      if(repVisitData){
        if(repVisitData.status.code  === 200) {
          showToast([`Rep Visit Scheduled Succesfully`], ToastTypes.SUCCESS);
          navigate('/cases');
        }
      }
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repVisitData, repVisitError]);

  return (
    <div className="container-fluid overflow-auto">
      <div className={"container"}>
        <div className="row justify-content-center">
          <div className="col-12">
            <AuthSubHeader/>

            <div className="card mt-4">
              <div className="card-header">
                <h1 className="m-0"> Schedule a rep visit with your rep </h1>
              </div>

              <div className="card-body">
                <p>Fill out the form below and your rep will get in touch with you shortly</p>
                <div>
                  <h5 className="text-primary mb-2 fw-normal"> I would like: </h5>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="requestReason" defaultChecked
                           id="supportOverview" onClick={() => onClickRadioButton('Request a call or visit')}/>
                    <label className="form-check-label" htmlFor="supportOverview">
                      Request a call or visit
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="requestReason" id="getJelmyto"
                           onClick={() => onClickRadioButton('Request samples')}/>
                    <label className="form-check-label" htmlFor="getJelmyto">
                      Request samples
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="requestReason" id="jelmytoSupport"
                           onClick={() => onClickRadioButton('Receive a product demonstration or additional training')}/>
                    <label className="form-check-label" htmlFor="jelmytoSupport">
                      Receive a product demonstration or additional training
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="requestReason" id="requestSupport"
                           onClick={() => onClickRadioButton('Request support resources')}/>
                    <label className="form-check-label" htmlFor="requestSupport">
                      Request support resources
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="requestReason" id="requestPatientEdu"
                           onClick={() => onClickRadioButton('Request patient education material/tools')}/>
                    <label className="form-check-label" htmlFor="requestPatientEdu">
                      Request patient education material/tools
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="requestReason" id="other"
                           onClick={() => onClickRadioButton('Other')}/>
                    <label className="form-check-label" htmlFor="other">
                      Other
                    </label>
                  </div>
                </div>
                <p className="mt-3">
                  By providing the information requested above, I authorize mannkindCares. to enter the
                  information
                  I have provided into a may contact me from time to time by telephone, mail, or email to provide
                  information about products or services that may be of interest to me. I understand that the
                  information
                  will be treated confidentially and will be accessed only by authorized personnel or third parties
                  under
                  contract with mannkindCares. or its affiliates.
                </p>
                <button type="button" className="btn btn-primary" disabled={loading} onClick={scheduleRepVisit}>
                  Request Visit
                </button>
              </div>
            </div>
            <FooterText footerType="black"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRepVisit;
